import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { EmployersListPage } from '@/features/employers';
import { workspaceSearchSchema } from '@/patterns';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/employers/')({
  validateSearch: workspaceSearchSchema.extend({ bank: zSearchText(), listed: zSearchText(), category: zSearchText(), state: z.enum(['on_list', 'not_on_list', 'no_classification']).optional().catch(undefined), new: zSearchText() }),
  component: function Employers() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <EmployersListPage search={search} onSearchChange={(patch, o) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false })} />;
  },
});
